import React from "react";
import "./StatusCard.scss";
import {TT_DON_KINH} from "types/enums";
const StatusCard = props => {
  const {status} = props;
  const setClassName = status => {
    if (status == TT_DON_KINH.CHUA_BAN) {
      return "pending";
    } else if (status == TT_DON_KINH.DA_BAN) {
      return "done";
    } else if (status == TT_DON_KINH.HUY) {
      return "cancel";
    } else if (status == TT_DON_KINH.HOAN_LAI) {
      return "return";
    }
  };
  const setText = status => {
    if (status == TT_DON_KINH.CHUA_BAN) {
      return "Chưa bán";
    } else if (status == TT_DON_KINH.DA_BAN) {
      return "Đã bán";
    } else if (status == TT_DON_KINH.HUY) {
      return "Hủy";
    } else if (status == TT_DON_KINH.HOAN_LAI) {
      return "Đã hoàn lại";
    }
  };

  return (
    <div className={`${setClassName(status)} status-card`}>
      {setText(status)}
    </div>
  );
};
export default StatusCard;
